import { request } from "./client";

const MAINTENANCE_DEFAULTS = { enabled: false };
const FEATURE_FLAG_DEFAULTS = { staking: true, offerwall: true, leaderboard: true, referrals: true, ads: true, cptToCisConversion: false };
const REFERRAL_REWARDS_DEFAULTS = {
  signupReferrerCis: 100,
  signupReferredCis: 100,
  completionReferrerCis: 1900,
  completionReferredCis: 900,
  stakingReferrerCis: 3000,
};
const CIS_REWARDS_DEFAULTS = {
  post: 10,
  likeReceived: 0.1,
  commentReceived: 0.5,
  streakLoginDay: 40,
  stakingFactor: 0.2,
  cptToCisRate: 40,
};

export const getPlatformSettings = async () => {
  const res = await request("/settings");
  const data = res?.data ?? res ?? {};
  return {
    maintenanceMode: { ...MAINTENANCE_DEFAULTS, ...data.maintenanceMode },
    featureFlags: { ...FEATURE_FLAG_DEFAULTS, ...data.featureFlags },
    referralRewards: { ...REFERRAL_REWARDS_DEFAULTS, ...data.referralRewards },
    cisRewards: { ...CIS_REWARDS_DEFAULTS, ...data.cisRewards },
  };
};
